import { render, staticRenderFns } from "./AddPath.vue?vue&type=template&id=98bfa074&scoped=true"
import script from "./AddPath.vue?vue&type=script&lang=js"
export * from "./AddPath.vue?vue&type=script&lang=js"
import style0 from "./AddPath.vue?vue&type=style&index=0&id=98bfa074&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bfa074",
  null
  
)

export default component.exports